import { useQueryClient } from "@tanstack/react-query";
import { useToastMessagesStore } from "@/Stores/ToastMessagesStore";
import { useParams } from "react-router-dom";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import { can } from "@/Util/permissionChecks";
import { useGetClient } from "@/Service/Api/V1/ApiHooks/Clients/useGetClient";
import { useUpdateClient } from "@/Service/Api/V1/ApiHooks/Clients/useUpdateClient";
import ClientForm, { ClientFormData } from "@/Components/Forms/Form/ClientForm";
import ContentLoadingTemplate from "@/Components/Templates/ContentLoadingTemplate";

const ClientPage = () => {
    const queryClient = useQueryClient();
    const addToastMessage = useToastMessagesStore((state) => state.addToastMessage);

    const { clientId } = useParams();
    const { data: client, isLoading } = useGetClient({
        requestParams: {
            client_id: Number(clientId)
        },
        enabled: !!clientId
    });
    const { mutateAsync: updateClient, isPending } = useUpdateClient();

    const handleUpdateClient = async (data: ClientFormData) => {
        if(!client?.id) return;
        await updateClient({
            client_id: client?.id.toString(),
            UpdateClientRequest: {
                ...data,
            }
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: QueryKeys.clients._def
                });
                addToastMessage({
                    severity: 'success',
                    summary: 'Client updated',
                    detail: 'Client has been updated successfully',
                });
            },
            onError: (error) => {
                addToastMessage({
                    severity: 'error',
                    summary: 'Failed to update client',
                    detail: error.message,
                });
            }
        });
    };

    if(isLoading) {
        return <ContentLoadingTemplate/>;
    }

    return (
        <PageLayout>
            <ClientForm
                initFormData={client}
                onSubmit={handleUpdateClient}
                isProcessing={isPending}
                onSubmitButtonLabel='Update client'
                onSubmitButtonDisabled={!can('edit:client')}
            />
        </PageLayout>
    );
};
export default ClientPage;